module.exports = __webpack_public_path__ + "img/Zunge.a7bdebfb.svg";